<template>
  <div>
    <div id="modal" v-if="meetingModalOpen === true">
      <div class="modal-box">
        <img
          class="modal-close"
          src="../assets/fisher-icon-close.svg"
          @click="toggleModal()"
        />
        <h2 v-if="getMeetingModalType === 'create'">Create Meeting</h2>
        <h2 v-if="getMeetingModalType === 'edit'">Edit a Meeting</h2>
        <MeetingForm></MeetingForm>
      </div>
    </div>
    <div id="modal" v-if="addVisitorModal === true">
      <div class="modal-box">
        <img
          class="modal-close"
          src="../assets/fisher-icon-close.svg"
          @click="toggleVisitorsModal()"
        />
        <h2>Add Visitors</h2>
        <Visitors></Visitors>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import MeetingForm from "./meeting/MeetingForm.vue";
import Visitors from "./Visitors";

export default {
  name: "Modal",
  components: {
    MeetingForm,
    Visitors,
  },
  computed: mapGetters([
    "meetingModalOpen",
    "getMeetingModalType",
    "addVisitorModal",
  ]),
  methods: {
    ...mapMutations(["toggleModal", "toggleVisitorsModal"]),
  },
};
</script>

<style lang="scss" scoped src="@/styles/style-modal.scss">
</style>